import { LuCheck } from 'react-icons/lu'
import { Flex } from '@chakra-ui/react'

import theme from 'styles/theme'

import { OrderItemCircleStatus } from './models'

type Props = {
  circleStatus: OrderItemCircleStatus
}

const OrderItemStatusCircle = ({ circleStatus }: Props): JSX.Element => {
  const getCircleBorderColor = (status: OrderItemCircleStatus): string | undefined => {
    switch (status) {
      case OrderItemCircleStatus.NONE:
        return theme.token('colors.leid.gr')
      case OrderItemCircleStatus.AVAILABLE:
        return theme.token('colors.leid.sort')
      default:
        return undefined
    }
  }

  const getCircleBackgroundColor = (status: OrderItemCircleStatus): string | undefined => {
    switch (status) {
      case OrderItemCircleStatus.CURRENT:
        return theme.token('colors.leid.gul')
      case OrderItemCircleStatus.PASSED:
        return theme.token('colors.leid.grnn')
      case OrderItemCircleStatus.COMPLETED:
        return theme.token('colors.leid.mrkGrnn')
      case OrderItemCircleStatus.CANCELED:
        return theme.token('colors.leid.darkGrey')
      default:
        return undefined
    }
  }

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      border="1.615px"
      borderStyle={
        circleStatus === OrderItemCircleStatus.NONE || circleStatus === OrderItemCircleStatus.AVAILABLE
          ? 'solid'
          : undefined
      }
      borderColor={getCircleBorderColor(circleStatus)}
      backgroundColor={getCircleBackgroundColor(circleStatus)}
      borderRadius="50%"
      width="26px"
      height="26px"
    >
      {circleStatus !== OrderItemCircleStatus.NONE && circleStatus !== OrderItemCircleStatus.AVAILABLE && (
        <LuCheck size={20} />
      )}
    </Flex>
  )
}

export default OrderItemStatusCircle
